<content-viewer *ngIf="body" [content]="body" (docRendered)="handleDocRendered($event)"> </content-viewer>
<div *ngIf="!(currentQuery.length > 0 && currentQuery.length < 3)" class="results-count">Showing {{ resultsCount }} results</div>
<div *ngIf="currentQuery.length > 0 && currentQuery.length < 3" class="no-results-container">
  <div class="no-results-text error-text">Please enter at least 3 characters to search</div>
</div>
<div *ngIf="suggestedWord && searchResultResponse?.length === 0" class="correction-container">
  <span class="correction-link">
    Did you mean&nbsp;
    <b (click)="applyCorrection(suggestedWord)">{{ suggestedWord }}</b>?
  </span>
</div>

<div class="main-content-row">
  <section class="results-list">
    <ng-container *ngIf="searchResultResponse?.length > 0">
      <app-search-card toType="title"
        *ngFor="let response of searchResultResponse"
        [searchCardResponse]="response"
        [isLoading]="isLoading"
        [showSkeleton]="isLoading"
      ></app-search-card>
    </ng-container>
    <div *ngIf="currentQuery.length >= 3 && searchResultResponse?.length === 0" class="no-results-container">
      <div class="no-results-text">No results</div>
      <div class="no-results-text">
        Try using other terms, use our
        <app-link [to]="meta['solution-finder']?.path" class="no-results-link">Solution Finder, </app-link>
        or
        <app-link [to]="meta['solution-finder']?.contactSupport" class="no-results-link">Contact Support</app-link>
      </div>
    </div>
  </section>
  <section class="results-sidebar">
    <solution-finder-card [solutionFinderResponse]="meta['solution-finder']"></solution-finder-card>
    <contact-block class="contact-block"> </contact-block>
  </section>
</div>
